import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import Vant from 'vant'
import store from './store'
import ElementUI from 'element-ui'
import navMenu from '@/components/navMenu'
import foot from '@/components/foot'
import '@/assets/styles/global.less'
import 'element-ui/lib/theme-chalk/index.css'
import 'vant/lib/index.css'

Vue.use(Vant)
Vue.use(ElementUI)
Vue.component('nav-menu', navMenu)
Vue.component('foot', foot)
Vue.config.productionTip = false
Vue.prototype.$http = axios

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
